import salImport from "./salImport";

const regions = [
  { name: "Region", value: "Region" },
  { name: "Global", value: "Global" },
];

const instIds = [
  { name: "MSSAL", value: "MSSAL" },
  { name: "NRI", value: "NRI" },
];

const frequencies = [
  {
    name: 1,
    value: 1,
  },
  {
    name: 5,
    value: 5,
  },
  {
    name: 10,
    value: 10,
  },
  {
    name: 15,
    value: 15,
  },
  {
    name: 30,
    value: 30,
  },
];

const frequencyMapping = {
  OneDay: [
    {
      name: "1",
      value: "1",
    },
    {
      name: "5",
      value: "5",
    },
    {
      name: "10",
      value: "10",
    },
    {
      name: "15",
      value: "15",
    },
    {
      name: "30",
      value: "30",
    },
  ],
  FiveDay: [
    {
      name: "5",
      value: "5",
    },
    {
      name: "10",
      value: "10",
    },
    {
      name: "15",
      value: "15",
    },
    {
      name: "30",
      value: "30",
    },
  ],
  FifteenDay: [
    {
      name: "5",
      value: "5",
    },
    {
      name: "10",
      value: "10",
    },
    {
      name: "15",
      value: "15",
    },
    {
      name: "30",
      value: "30",
    },
    {
      name: "60",
      value: "60",
    },
  ],
  OneMonth: [
    {
      name: "10",
      value: "10",
    },
    {
      name: "15",
      value: "15",
    },
    {
      name: "30",
      value: "30",
    },
    {
      name: "60",
      value: "60",
    },
    {
      name: "d",
      value: "d",
    },
    {
      name: "w",
      value: "w",
    },
  ],
  ThreeMonth: [
    {
      name: "10",
      value: "10",
    },
    {
      name: "15",
      value: "15",
    },
    {
      name: "30",
      value: "30",
    },
    {
      name: "60",
      value: "60",
    },
    {
      name: "d",
      value: "d",
    },
    {
      name: "w",
      value: "w",
    },
  ],
  SixMonth: [
    {
      name: "d",
      value: "d",
    },
    {
      name: "w",
      value: "w",
    },
    {
      name: "m",
      value: "m",
    },
  ],
  YTD: [
    {
      name: "d",
      value: "d",
    },
    {
      name: "w",
      value: "w",
    },
    {
      name: "m",
      value: "m",
    },
  ],
  OneYear: [
    {
      name: "d",
      value: "d",
    },
    {
      name: "w",
      value: "w",
    },
    {
      name: "m",
      value: "m",
    },
  ],
  ThreeYear: [
    {
      name: "d",
      value: "d",
    },
    {
      name: "w",
      value: "w",
    },
    {
      name: "m",
      value: "m",
    },
  ],
  FiveYear: [
    {
      name: "d",
      value: "d",
    },
    {
      name: "w",
      value: "w",
    },
    {
      name: "m",
      value: "m",
    },
  ],
  TenYear: [
    {
      name: "d",
      value: "d",
    },
    {
      name: "w",
      value: "w",
    },
    {
      name: "m",
      value: "m",
    },
  ],
  FifteenYear: [
    {
      name: "d",
      value: "d",
    },
    {
      name: "w",
      value: "w",
    },
    {
      name: "m",
      value: "m",
    },
  ],
  Max: [
    {
      name: "m",
      value: "m",
    },
  ],
};

const intervals = [
  {
    name: "OneDay",
    value: "OneDay",
  },
  {
    name: "FiveDay",
    value: "FiveDay",
  },
  {
    name: "FifteenDay",
    value: "FifteenDay",
  },
  {
    name: "OneMonth",
    value: "OneMonth",
  },
  {
    name: "ThreeMonth",
    value: "ThreeMonth",
  },
  {
    name: "SixMonth",
    value: "SixMonth",
  },
  {
    name: "YTD",
    value: "YTD",
  },
  {
    name: "OneYear",
    value: "OneYear",
  },
  {
    name: "ThreeYear",
    value: "ThreeYear",
  },
  {
    name: "FiveYear",
    value: "FiveYear",
  },
  {
    name: "TenYear",
    value: "TenYear",
  },
  {
    name: "Max",
    value: "Max",
  },
];

const intervalsSet2 = [
  {
    name: "ThreeMonth",
    value: "ThreeMonth",
  },
  {
    name: "SixMonth",
    value: "SixMonth",
  },
  {
    name: "YTD",
    value: "YTD",
  },
  {
    name: "OneYear",
    value: "OneYear",
  },
  {
    name: "ThreeYear",
    value: "ThreeYear",
  },
  {
    name: "FiveYear",
    value: "FiveYear",
  },
  {
    name: "TenYear",
    value: "TenYear",
  },
  {
    name: "Max",
    value: "Max",
  },
];
const pdfOrientations = [
  { name: "portrait", value: "portrait" },
  { name: "landscape", value: "landscape" },
];

const pdfFormats = [
  { name: "Letter", value: "Letter" },
  { name: "A4", value: "A4" },
];

const benchmarkIds = [
  { name: "MstarOrCat", value: "mstarorcat" },
  { name: "Category", value: "category" },
  { name: "Morningstar", value: "morningstar" },
  { name: "Primary Prospectus", value: "prospectus_primary" },
];

const fonts = [
  { name: "Arial", value: "Arial" },
  { name: "MorningstarUniversNext", value: "MorningstarUniversNext" },
];

const timeFormats = [
  { name: "12H", value: "12H" },
  { name: "24H", value: "24H" },
];

const uiVersions = [
  { name: "v0", value: "v0" },
  { name: "v1", value: "v1" },
];

const newsServiceProdCodes = [
  { name: "IICOMUS", value: "IICOMUS" },
  { name: "Fin24", value: "Fin24" },
  { name: "SENS", value: "SENS" },
];

const quoteActiveTabIds = [
  { name: "null", value: "null" },
  { name: "quote", value: "quote" },
  { name: "keyStats", value: "keyStats" },
  { name: "tradingInformation", value: "tradingInformation" },
  { name: "news", value: "news" },
];

const firstRankedIndexes = [
  "!MSTAR",
  "MSAUAUDP",
  "MSCZCZKP,!MSTAR",
  "MSCZCZKP",
  "MSSESEKP,MSBEEURP",
  "MSHUHUFP",
  "MSATEURP",
  "MSBEEURP",
  "MSBRBRLP",
  "MSCACADP",
  "MSCLCLPP",
  "MSCNCNYP",
  "MSCOCOPP",
  "MSDKDKKP",
  "MSEGEGPP",
  "MSFIEURP",
  "MSFREURP",
  "MSDEEURP",
  "MSGREURP",
  "MSININRP",
  "MSIDIDRP",
  "MSIEEURP",
  "MSILILSP",
  "MSITEURP",
  "MSJPJPYP",
  "MSMYMYRP",
  "MSMXMXNP",
  "MSMAMADP",
  "MSNLEURP",
  "MSNZNZDP",
  "MSNONOKP",
  "MSPEPENP",
  "MSPHPHPP",
  "MSPLPLNP",
  "MSPTEURP",
  "MSRURUBP",
  "MSSGSGDP",
  "MSZAZARP",
  "MSKRKRWP",
  "MSESEURP",
  "MSSESEKP",
  "MSCHCHFP",
  "MSTWTWDP",
  "MSTHTHBP",
  "MSTRTRYP",
  "MSGBGBPP",
];

export default {
  salImport,
  fonts,
  uiVersions,
  timeFormats,
  regions,
  instIds,
  frequencies,
  intervals,
  benchmarkIds,
  intervalsSet2,
  frequencyMapping,
  newsServiceProdCodes,
  quoteActiveTabIds,
  firstRankedIndexes,
  pdfOrientations,
  pdfFormats,
};
